import { useEffect } from "react";

export const useLockBodyScroll = (lock: boolean = true) => {
  useEffect(() => {
    if (!lock) return;

    const originalOverflowBody = document.body.style.overflow;
    const originalOverflowHtml = document.documentElement.style.overflow;

    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden";
    document.body.setAttribute("data-scroll-locked", "1");

    return () => {
      document.body.style.overflow = originalOverflowBody;
      document.documentElement.style.overflow = originalOverflowHtml;
      document.body.removeAttribute("data-scroll-locked");
    };
  }, [lock]);
};
